(ns ui.view.sheets.model)

(def root-path [::state])

(def sheet-stack-path [:sheet-stack])

(def sheet-stack-full-path
  (into root-path sheet-stack-path))

(def sheet-states-path [:sheet-states])

(def sheet-states-full-path
  (into root-path sheet-states-path))

(defn sheet-state-full-path
  [sheet-id]
  (conj sheet-states-full-path sheet-id))
